// extracted by mini-css-extract-plugin
export default {"additionalSidePanel__container":"AdditionalSidePanel_additionalSidePanel__container__Rk9sF"};